import { render, staticRenderFns } from "./IncreaseTheProject.vue?vue&type=template&id=5a1d2efd&scoped=true"
import script from "./IncreaseTheProject.vue?vue&type=script&lang=js"
export * from "./IncreaseTheProject.vue?vue&type=script&lang=js"
import style0 from "./IncreaseTheProject.vue?vue&type=style&index=0&id=5a1d2efd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d2efd",
  null
  
)

export default component.exports